<template src="./Campaigns.html"></template>
<script>
import mixins from "../../../../Mixins.js";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      popupCampaign: false,
      idCompany: null,
      companyName: "",
      companies: [],
      campaigns: [],
      plans: [],
      campaign: {
        name: "",
        contractId: "",
        customerPlanId: "",
        companyId: "",
        webClinicId: "",
      },
      selectedCompanyOrClinic: "",
      titlePopUpCampaign: "",
      contracts: [],
      contract: null,
      customerPlan: null,
      webClinics: [],
      invalidFields: {
        name: false,
        contract: false,
        clinic: false,
        company: false,
        plan: false,
        status: false,
        selectedCompanyOrClinic: false,
      },
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
      search: "",
    };
  },
  watch: {
    campaigns: function(newVal){
      const vm = this;
      vm.campaigns = newVal;
    },
    selectedCompanyOrClinic: function (newVal) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(newVal) === false) {
        vm.invalidFields.selectedCompanyOrClinic = false;
      }
    },
    contract: function(newVal) {
      const vm = this;
      if(!vm.testNullUndefinedEmpty(newVal)) {
        vm.campaign.contractId = newVal.id;
        vm.invalidFields.contractId = false;
      }
    },
    customerPlan: function(newVal) {
      const vm = this;
      if(!vm.testNullUndefinedEmpty(newVal)) {
        vm.campaign.customerPlanId = newVal.id;
        vm.invalidFields.customerPlanId = false;
      }
    },
    currentx: function () {
      this.getCampaigns();
    },
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  methods: {
    init() {
      const vm = this;
        vm.idCompany = 2;
        vm.getCampaigns();
        vm.getContract();
        vm.getPlans();
      
    },
    removeCampaign(id) {
      const vm = this;
      vm.axios
        .delete(vm.$store.state.filooServer + "campaign/" + id, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.$vs.notify({
              title: "Sucesso!",
              text: "O plano Foi removido com sucesso!",
              color: "success",
              icon: "verified_user",
              position: "top-right",
            });
            vm.getPlan();
          }
        });
    },
    getContractName(contractId) {
      const vm = this;
      let contract = [];
      var contractName = "";
      contract = vm.contracts.filter(c => c.id == contractId);
      contractName = contract.name;
      return contractName;
    },
    validateFields() {
      const vm = this;
      let valid = true;
      if (vm.testNullUndefinedEmpty(vm.campaign.name)) {
        valid = false;
        vm.invalidFields.name = true;
      }
      if (vm.testNullUndefinedEmpty(vm.contract)) {
        valid = false;
        vm.invalidFields.contract = true;
      }
      if (vm.testNullUndefinedEmpty(vm.customerPlan)) {
        valid = false;
        vm.invalidFields.plan = true;
      }
      if (vm.campaign.active === null) {
        valid = false;
        vm.invalidFields.status = true;
      }
      if (valid == false) {
        vm.$vs.notify({
          title: "Atenção",
          text: "Campos obrigatórios ou inválidos.",
          position: "top-right",
          color: "warning",
          icon: "error",
        });
      } else {
        if (vm.testNullUndefinedEmpty(vm.campaign.id)) {
          vm.saveNewCampaign();
        } else {
          vm.updateCampaign();
        }
      }
    },
    editCampaign(campaign) {
      const vm = this;
      vm.titlePopUpCampaign =
        "Editar modelo de contratação: " + campaign.contractName;
      (vm.invalidFields = {
        name: false,
        contract: false,
        clinic: false,
        company: false,
        plan: false,
        status: false,
        selectedCompanyOrClinic: false,
      }),
        vm.getCampaign(campaign.campaignId);
      vm.popupCampaign = true;
    },

    addNewCampaign() {
      const vm = this;
      vm.popupCampaign = true;
      vm.titlePopUpCampaign = "Novo modelo de contratação";
      vm.selectedCompanyOrClinic = "";
      vm.contract = null,
      vm.customerPlan = null,
      vm.campaign = {
        name: "",
        contractId: "",
        customerPlanId: "",
        companyId: "",
        webClinicId: "",
        active: false,
      };
    },
    saveNewCampaign() {
      const vm = this;

      vm.campaign.companyId = parseInt(vm.idCompany);
      vm.campaign.webClinicId = null;
      vm.axios
        .post(vm.$store.state.filooServer + "campaign/", vm.campaign, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.popupCampaign = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Dados registrados com sucesso.",
              icon: "success",
            }).then(function () {
              vm.getCampaigns();
            });
          }
        })
        .catch(function () {
          vm.popupCampaign = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível salvar o modelo de contratação " +
              vm.campaign.name +
              ". Por favor contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    getCompaniesRegistered() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/companies?page=0&size=50&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.companies = response.data.content;
          }
        });
    },
    getPlans() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "customerplan", {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status == 200) {
            vm.plans = response.data;
          }
        });
    },
    updateCampaign() {
      const vm = this;
      vm.campaign.companyId = parseInt(vm.idCompany);
      vm.campaign.webClinicId = null;

      vm.axios
        .put(vm.$store.state.filooServer + "campaign/", vm.campaign, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.popupCampaign = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Dados alterados com sucesso.",
              icon: "success",
            }).then(function () {
              vm.getCampaigns();
            });
          }
        })
        .catch(function () {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    getCampaign(campaignId) {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer + "campaign/find_by_id/" + campaignId,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.campaign = response.data;
          }
        })
        .catch(function () {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível localizar o modelo de contratação, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    getContract() {
      const vm = this;
      this.axios
        .get(vm.$store.state.filooServer + "contract", {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          vm.contracts = response.data;
        });
    },
    getWebClinics() {
      const vm = this;
      this.axios
        .get(vm.$store.state.filooServer + "webclinics/getAll", {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          vm.webClinics = response.data;
        });
    },
    getCampaigns() {
      const vm = this;
      this.axios
        .get(
          vm.$store.state.filooServer +
            `campaign/find_by_companyid/2?page=${vm.currentx-1}&size=10&search=${vm.search}`, {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.campaigns = response.data.content;
            for (let c in vm.campaigns) {
              vm.campaigns[c].statusText =
                vm.campaigns[c].active === true ? "Ativo" : "Inativo";
            }
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
          }
        });
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
    handleSearch(search) {
      this.search = search
      this.currentx === 1 ? this.getCampaigns() : this.currentx = 1
    },
  },
};
</script>

<style lang="scss" src="./Campaigns.scss">
</style>